import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useRef, useState } from "react";
import { useUtils } from "@/app/hooks/useUtils";

export default function ViewPartialDetails({ orders }) {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { maskMobile } = useUtils();

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <div className="text-blue-600 text-sm font-medium cursor-pointer" onClick={() => setOpen(true)}>
        View Details
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all 
                
                sm:max-w-3xl
                sm:w-full  sm:p-6`}
                >
                  <div className="items-center flex justify-between ">
                    <p className="text-base font-semibold">Partial Order Details</p>
                    <p>
                      <XMarkIcon className="w-4 h-4 cursor-pointer font-bold text-sm" onClick={() => setOpen(false)} />
                    </p>
                  </div>
                  <hr className="my-2" />
                  <div className="">
                    <div className="py-2 flex grid-row-2 gap-2">
                      <p className="text-sm font-semibold w-1/4">Suborder ID</p>
                      <p className="text-sm">{orders?.order_details?.sub_order_id}</p>
                    </div>
                    <div className="py-2 flex grid-row-2 gap-2">
                      <p className="text-sm font-semibold w-1/4">Client Name</p>
                      <p className="text-sm">{orders?.client_details?.name}</p>
                    </div>
                    <div className="py-2 flex grid-row-2 gap-2">
                      <p className="text-sm font-semibold w-1/4">Client Phone No.</p>
                      <p className="text-sm">{maskMobile(String(orders?.client_details?.mobile ?? "")) || "NA"}</p>
                    </div>
                    <div className="py-2 flex grid-row-2 gap-2">
                      <p className="text-sm font-semibold w-1/4">All Items Ordered</p>
                      <ul>
                        {orders?.order_details?.original_order_items?.map((item, index) => (
                          <li key={index} className="text-sm py-1">
                            {index + 1}. {item?.item_name} ({item?.quantity_to_pick} Qty)
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="py-2 flex grid-row-2 gap-2 ">
                      <p className="text-sm font-semibold w-1/4">Missing Items</p>
                      <ul>
                        {orders?.order_details?.missing_order_items?.map((item, index) => (
                          <li key={index} className="text-sm py-1">
                            {index + 1}. {item?.item_name} ({item?.quantity_to_pick} Qty)
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="py-2 flex grid-row-2 gap-2">
                      <p className="text-sm font-semibold w-1/4">New Suborder ID</p>
                      {orders?.order_details?.child_sub_order_id ? (
                        <p className="text-sm">{orders?.order_details?.child_sub_order_id}</p>
                      ) : (
                        <p className="text-sm text-red-600"> Not Created</p>
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
